import {
  type AnchorHTMLAttributes,
  type ButtonHTMLAttributes,
  type ElementType,
  type MouseEvent,
  type Ref,
} from "react"

import { Link } from "@/components/ui/link"

export type ButtonOrLinkProps = (ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>) & {
  onClick?: (e: MouseEvent<HTMLElement>) => void
  as?: ElementType
}

function ButtonOrLink({
  ref,
  as,
  href,
  type = "button",
  ...props
}: ButtonOrLinkProps & {
  ref?: Ref<HTMLButtonElement | HTMLAnchorElement>
}) {
  if (href) {
    const anchorRef = ref as Ref<HTMLAnchorElement>
    if (as === "a") {
      return <a href={href} {...props} ref={anchorRef} />
    } else {
      return <Link href={href} {...props} ref={anchorRef} />
    }
  }

  const buttonRef = ref as Ref<HTMLButtonElement>
  const Element = as || "button"
  return <Element {...props} type={type} ref={buttonRef} />
}

ButtonOrLink.displayName = "ButtonOrLink"

export { ButtonOrLink }
